import RechercheSimple from '@/view/recherche/RechercheSimple';
import RechercheAvancee from '@/view/recherche/RechercheAvancee';
import MesRecherchesAvancees from '@/view/recherche/MesRecherchesAvancees';
import DetailPersonneMorale from '@/view/personnemorale/DetailPersonneMorale';
import DetailPersonnePhysique from '@/view/personnephysique/DetailPersonnePhysique';
import DetailInstance from '@/view/instance/DetailInstance';
import ListMesInstances from '@/view/workflow/ListMesInstances';

const RECHERCHESIMPLE_BREADCRUMB = {
  code: 'menu.recherche.rechercheSimple',
  link: {
    name: 'recherche/recherchesimple',
  },
};

const RECHERCHEAVANCEE_BREADCRUMB = {
  code: 'menu.recherche.rechercheAvancee',
  link: {
    name: 'recherche/rechercheavancee',
  },
};

export default [
  {
    path: '/recherche/recherchesimple',
    name: 'recherche/recherchesimple',
    component: RechercheSimple,
    props: {},
    meta: {
      auth: 'hasRole(PRIV_RECHERCHE_SIMPLE)',
      breadcrumb: () => [{ code: 'menu.recherche.rechercheSimple' }],
    },
  },
  {
    path: '/recherche/recherchesimple/personne-morale/:id',
    name: 'recherche/recherchesimple/personne-morale/detail',
    component: DetailPersonneMorale,
    props: {},
    meta: {
      auth: 'hasRole(PRIV_PERSONNE_MORALE_READ)',
      breadcrumb: () => [
        RECHERCHESIMPLE_BREADCRUMB,
        { code: 'personneMorale.detail.title.default' },
      ],
    },
  },
  {
    path: '/recherche/recherchesimple/personne-physique/:id',
    name: 'recherche/recherchesimple/personne-physique/detail',
    component: DetailPersonnePhysique,
    props: {},
    meta: {
      auth: 'hasRole(PRIV_PERSONNE_PHYSIQUE_READ)',
      breadcrumb: () => [
        RECHERCHESIMPLE_BREADCRUMB,
        { code: 'personnePhysique.detail.title' },
      ],
    },
  },
  {
    path: '/recherche/recherchesimple/instance/:id',
    name: 'recherche/recherchesimple/instance/detail',
    component: DetailInstance,
    props: {},
    meta: {
      auth: 'hasRole(PRIV_INSTANCE_READ)',
      breadcrumb: () => [
        RECHERCHESIMPLE_BREADCRUMB,
        { code: 'instance.detail.title' },
      ],
    },
  },
  {
    path: '/recherche/mesrecherchesavancees',
    name: 'recherche/mesrecherchesavancees',
    component: MesRecherchesAvancees,
    props: {},
    meta: {
      auth: 'hasRole(PRIV_RECHERCHE_AVANCEE)',
      breadcrumb: () => [{ code: 'menu.recherche.mesRecherchesAvancees' }],
    },
  },

  {
    path: '/recherche/rechercheavancee',
    name: 'recherche/rechercheavancee',
    component: RechercheAvancee,
    props: {},
    meta: {
      auth: 'hasRole(PRIV_RECHERCHE_AVANCEE)',
      breadcrumb: () => [{ code: 'menu.recherche.rechercheAvancee' }],
    },
  },
  {
    path: '/recherche/rechercheavancee/personne-morale/:id',
    name: 'recherche/rechercheavancee/personne-morale/detail',
    component: DetailPersonneMorale,
    props: {},
    meta: {
      auth: 'hasRole(PRIV_PERSONNE_MORALE_READ)',
      breadcrumb: () => [
        RECHERCHEAVANCEE_BREADCRUMB,
        { code: 'personneMorale.detail.title.default' },
      ],
    },
  },

  {
    path: '/creation/personnephysique',
    name: 'creation/personnephysique',
    component: DetailPersonnePhysique,
    props: {
      enModeCreation: true,
      enDemandeCreation: false,
    },
    meta: {
      auth: 'hasRole(PRIV_PERSONNE_PHYSIQUE_WRITE)',
      breadcrumb: () => [{ code: 'personnePhysique.creation.title' }],
    },
  },

  {
    path: '/creation/personnemorale',
    name: 'creation/personnemorale',
    component: DetailPersonneMorale,
    props: {
      enModeCreation: true,
    },
    meta: {
      auth: 'hasRole(PRIV_PERSONNE_MORALE_WRITE)',
      breadcrumb: () => [{ code: 'personneMorale.creation.title' }],
    },
  },

  {
    path: '/creation/instance',
    name: 'creation/instance',
    component: DetailInstance,
    props: {
      enModeCreation: true,
      enDemandeCreation: false,
    },
    meta: {
      auth: 'hasRole(PRIV_INSTANCE_WRITE)',
      breadcrumb: () => [{ code: 'instance.creation.title' }],
    },
  },

  {
    path: '/recherche/rechercheavancee/personne-physique/:id',
    name: 'recherche/rechercheavancee/personne-physique/detail',
    component: DetailPersonnePhysique,
    props: {},
    meta: {
      auth: 'hasRole(PRIV_PERSONNE_PHYSIQUE_READ)',
      breadcrumb: () => [
        RECHERCHEAVANCEE_BREADCRUMB,
        { code: 'personnePhysique.detail.title' },
      ],
    },
  },
  {
    path: '/recherche/rechercheavancee/instance/:id',
    name: 'recherche/rechercheavancee/instance/detail',
    component: DetailInstance,
    props: {},
    meta: {
      auth: 'hasRole(PRIV_INSTANCE_READ)',
      breadcrumb: () => [
        RECHERCHEAVANCEE_BREADCRUMB,
        { code: 'instance.detail.title' },
      ],
    },
  },
  {
    path: '/recherche/mesinstances',
    name: 'recherche/mesinstances',
    component: ListMesInstances,
    props: {},
    meta: {
      auth: 'hasRole(PRIV_RECHERCHE_AVANCEE)',
      breadcrumb: () => [{ code: 'menu.instances' }],
    },
  },
];
